export default "__VITE_ASSET__DSeD$xDU__"